import { api } from "api/api";
import { AxiosError } from "axios";
import Conta from "model/administracao/cadastro/Conta";
import Modulo from "model/administracao/cadastro/Modulo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class ContaService implements BaseServiceCadastros<Conta> {

    pesquisar(page: Pageable) {
        return new Promise<Page>((resolve, reject): void => {
            const url = `/conta/pesquisar`;
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Conta>((resolve, reject): void => {
            api
                .get(`/conta/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {
                    console.log(err)
                    reject(err?.response||"")
                
                });
        });
    }

    modulos() {
        return new Promise<Array<Modulo>>((resolve, reject): void => {
            const url = `/conta/modulos`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    zones() {
        return new Promise<Array<string>>((resolve, reject): void => {
            const url = `/conta/zones`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(conta: Conta) {
        return new Promise<Conta>((resolve, reject): void => {
            api
                .post(`/conta/incluir`, JSON.stringify(conta))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(conta: Conta) {
        return new Promise<Conta>((resolve, reject): void => {
            api
                .put(`/conta/editar`, JSON.stringify(conta))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/conta/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarLogo(id: number) {
        return new Promise<Blob>((resolve, reject): void => {
            api
                .get(`/conta/logo/${id}`, { responseType: 'arraybuffer' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'image/png' }); // ou o tipo de conteúdo apropriado
                    resolve(blob);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gravarLogo(id: number, logo: File) {
        return new Promise<void>((resolve, reject): void => {
            const formData = new FormData();
            formData.append("logo", logo as Blob);

            api
                .postForm(`/conta/logo/${id}`, formData)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getModulosDisponiveis() {
        return new Promise<Modulo[]>((resolve, reject) => {
            api
                .get(`/conta/modulosDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response))
        })
    }

    temModulo(modulos: Modulo[], sigla: string): boolean {
        return modulos.findIndex(modulo => modulo.sigla === sigla)>-1;
    }


}

export default ContaService;
